import { render, staticRenderFns } from "./PessoaPartial.vue?vue&type=template&id=642d699a&"
import script from "./PessoaPartial.vue?vue&type=script&lang=js&"
export * from "./PessoaPartial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports